import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function HomeComponent() {
  const navigate = useNavigate();
  const [branches, setBranches] = useState([]);
  const [booths, setBooths] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const branchesPerPage = 3;
  const [currentBoothPage, setCurrentBoothPage] = useState(0);
  const boothsPerPage = 5;
  const totalSteps = 5;
  const stepDuration = 5000; // 5 seconds
  const [currentStep, setCurrentStep] = useState(1);

  const steps = [
    { title: "Sign In / Register", description: "Create an account or log in to your existing account to get started. This step ensures you have access to all the features and services.", img: require('../../assets/login.png') },
    { title: "Booking", description: "Select your preferred service and schedule a booking. Choose a convenient time and date that suits your needs.", img: require('../../assets/booking.png') },
    { title: "Payment", description: "Complete your booking by making a payment through our secure payment gateway. We accept various payment methods for your convenience.", img: require('../../assets/payment.png') },
    { title: "Receive Code via Email", description: "Once your payment is confirmed, a unique code will be sent to your registered email address. Please check your inbox.", img: require('../../assets/email.jpg') },
    { title: "Enter Code and Start", description: "Enter the code you received via email to activate the service. You're now ready to begin!", img: require('../../assets/entercode.jpg') },
  ];

  const images = [
    require('../../assets/home1.jpg'),
    require('../../assets/home2.jpg'),
    require('../../assets/home3.jpg'),
    require('../../assets/home4.jpg'),
    require('../../assets/home5.jpg')
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval); // Clean up the interval on component unmount
  }, [images.length]);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/branch/paging?pageSize=6');
        const branchData = response.data.map(branch => ({
          branchID: branch.branchID,
          branchName: branch.branchName,
          branchPhotoUrl: branch.branchPhotos.length > 0 ? branch.branchPhotos[0].branchPhotoUrl : 'https://via.placeholder.com/300x200', 
          address: branch.address,
          town: branch.town,
          city: branch.city,
        }));
        setBranches(branchData);
      } catch (error) {
        console.error('Error fetching branch data:', error);
      }
    };
    
    const fetchBooths = async () => {
      try {
        const response = await axios.get('https://fboothapi.azurewebsites.net/api/booth/paging?pageSize=10');
        const boothData = await Promise.all(
          response.data.map(async (booth) => {
            const branchResponse = await axios.get(`https://fboothapi.azurewebsites.net/api/branch/${booth.branchID}`);
            return {
              ...booth,
              branchName: branchResponse.data.branchName,
              boothPhotoUrl: booth.boothPhotos.length > 0 ? booth.boothPhotos[0].boothPhotoUrl : 'https://via.placeholder.com/300x200',
            };
          })
        );
        setBooths(boothData);
      } catch (error) {
        console.error('Error fetching booth data:', error);
      }
    }

    fetchBranches();
    fetchBooths();
  }, []);

  const handleBoothNextPage = () => {
    if ((currentBoothPage + 1) * boothsPerPage < booths.length) {
      setCurrentBoothPage(currentBoothPage + 1);
    }
  };

  const handleBoothPrevPage = () => {
    if (currentBoothPage > 0) {
      setCurrentBoothPage(currentBoothPage - 1);
    }
  };

  const currentBooths = booths.slice(
    currentBoothPage * boothsPerPage,
    (currentBoothPage + 1) * boothsPerPage
  );
  const handleBranchClick = (branchID) => {
    navigate(`/branchdetail/${branchID}`); // Navigate to the branch detail page
  };

  const handleBoothClick = (boothID) => {
    navigate(`/boothdetail/${boothID}`); // Navigate to BoothDetail component
  };
  const handleNextPage = () => {
    if ((currentPage + 1) * branchesPerPage < branches.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const currentBranches = branches.slice(
    currentPage * branchesPerPage,
    (currentPage + 1) * branchesPerPage
  );
  const showStep = (step) => {
    setCurrentStep(step);
  };

  const nextStep = () => {
    setCurrentStep((prevStep) => (prevStep % totalSteps) + 1);
  };

  useEffect(() => {
    const interval = setInterval(nextStep, stepDuration);
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div>
      {/* Hero Carousel */}
      <section className="relative h-96 flex justify-center items-center bg-black">
  <div className="absolute inset-0">
    <img 
      src={images[currentImageIndex]} 
      alt="Hero Image" 
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black opacity-70"></div>
  </div>
  <div className="relative z-10 text-center text-white p-6">
    <h1 className="text-5xl font-extrabold mb-6 drop-shadow-md">CAPTURE YOUR MOMENTS</h1>
    <p className="text-xl mb-8 max-w-lg mx-auto drop-shadow-md">FBooth offers comprehensive solutions for capturing and enhancing photos.</p>
  </div>
</section>


      {/* Popular Branches Section */}
      <section className="px-4 py-8 bg-F3F8FF">
  <h2 className="text-2xl font-bold text-blue-900 pl-8 mb-8">Popular Branches</h2>
  <div className="flex flex-wrap justify-center">
    {currentBranches.map(branch => (
      <div 
        key={branch.branchID} 
        className="w-1/3 px-8 py-2"
        onClick={() => handleBranchClick(branch.branchID)}
      >
        <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform hover:scale-105">
          <div className="relative">
            <img 
              src={branch.branchPhotoUrl} 
              alt={branch.branchName} 
              className="w-full h-64 object-cover rounded-t-lg mb-0" 
            />
            <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white p-2">
              <h3 className="text-lg font-bold">{branch.branchName}</h3>
            </div>
          </div>
          <div className="p-4 text-center">
            <p className="text-blue-900">{branch.address}, {branch.town}, {branch.city}</p>
          </div>
        </div>
      </div>
    ))}
  </div>

  <div className="flex justify-center mt-4 space-x-2">
    <button 
      className="bg-[#C6CFFF] rounded-full p-2 shadow hover:shadow-lg"
      onClick={handlePrevPage}
      disabled={currentPage === 0} 
    >
      <span>&larr;</span>
    </button>
    <button 
      className="bg-[#C6CFFF] rounded-full p-2 shadow hover:shadow-lg"
      onClick={handleNextPage}
      disabled={(currentPage + 1) * branchesPerPage >= branches.length} 
    >
      <span>&rarr;</span>
    </button>
  </div>
</section>







      {/* Booths Section */}
      <section className="px-4 py-8 bg-white">
      <h2 className="text-2xl font-bold text-blue-900 pl-8 mb-8">Booths Loved by Guests</h2>
      <div className="flex flex-wrap justify-center">
        {currentBooths.map(booth => (
          <div 
            key={booth.boothID} 
            className="w-1/5 px-8 py-2"
            onClick={() => handleBoothClick(booth.boothID)}
          >
            <div className="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform hover:scale-105">
              <div className="relative">
                <img 
                  src={booth.boothPhotoUrl} 
                  alt={booth.boothName} 
                  className="w-full h-64 object-cover rounded-t-lg mb-0" 
                />
                <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white p-2">
                  <h3 className="text-lg font-bold">{booth.boothName}</h3>
                </div>
              </div>
              <div className="p-4 text-center">
                <p className="text-blue-900">{booth.branchName}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-4 space-x-2">
        <button 
          className="bg-[#C6CFFF] rounded-full p-2 shadow hover:shadow-lg"
          onClick={handleBoothPrevPage}
          disabled={currentBoothPage === 0} 
        >
          <span>&larr;</span>
        </button>
        <button 
          className="bg-[#C6CFFF] rounded-full p-2 shadow hover:shadow-lg"
          onClick={handleBoothNextPage}
          disabled={(currentBoothPage + 1) * boothsPerPage >= booths.length} 
        >
          <span>&rarr;</span>
        </button>
      </div>
    </section>



    <section className="relative bg-F3F8FF py-12">

    <h2 className="text-4xl font-bold text-blue-900 text-center mb-8">How to use</h2>
      <div className="container mx-auto px-4 flex items-center">
        <div className="w-1/3 flex flex-col items-start">
          {/* Steps Navigation */}
          {steps.map((step, index) => (
            <div key={index} className="flex items-center mb-8 cursor-pointer" onClick={() => showStep(index + 1)}>
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-[#C6CFFF]
                ${currentStep === index + 1 ? 'bg-white' : 'bg-white'}`}
              >
                {index + 1}
              </div>
              <div className={`ml-4 ${currentStep === index + 1 ? 'text-[#E8D3FF]' : 'text-gray-800'}`}>
                <h3 className="text-xl font-semibold">{step.title}</h3>
              </div>
            </div>
          ))}
        </div>
        <div className="w-2/3 flex justify-center items-center">
          {/* Step Details with an image */}
          <div className="w-full relative p-8 bg-white rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-C6CFFF mb-4">{steps[currentStep - 1].title}</h3>
            <p className="text-gray-700 mb-6">{steps[currentStep - 1].description}</p>
            <img
        src={steps[currentStep - 1].img}
        alt="Step Visual"
        className="w-[1000px] h-[500px] rounded-lg"
      />
          </div>
        </div>
      </div>
    </section>

      {/* Stickers Section */}
      <div className="py-12 bg-white flex justify-center items-center">
        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="flex flex-col items-center md:items-end pr-16 text-center md:text-right">
            <h2 className="text-blue-900 text-2xl font-bold mb-4">We have a lot of stickers</h2>
            <img src="https://png.pngtree.com/png-clipart/20230124/original/pngtree-hand-drawing-cute-stickers-png-image_8928586.png" className="w-full max-w-sm h-auto object-contain" alt="" />
          </div>
          <div className="bg-[#DEECFF] rounded-xl p-8 text-center md:text-left">
            <h2 className="text-blue-900 text-4xl font-black mb-4">Stickers are updated regularly</h2>
            <p className="text-blue-900 text-lg">We have specially designed stickers to make your photos special. Come to FBooth, you can create your own photos with lovely and diverse stickers.</p>
          </div>
        </div>
      </div>

      {/* Layout Section */}
      <div className="py-12 bg-F3F8FF flex justify-center items-center">
        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="bg-[#DEECFF] rounded-xl p-8 text-center md:text-left">
            <h2 className="text-blue-900 text-4xl font-black mb-4">Diversity is always a top priority</h2>
            <p className="text-blue-900 text-lg">In addition to the variety of stickers, FBooth also constantly creates and develops new layouts. We always ensure diversity in each customer's photo.</p>
          </div>
          <div className="flex flex-col items-center md:items-start pl-16 text-center md:text-left">
            <h2 className="text-blue-900 text-2xl font-bold mb-4">Variety of photo layouts</h2>
            <img 
  src="https://i.pinimg.com/originals/35/36/d4/3536d4947047cc51fdc08db9746904bc.png"  
  className="w-full max-w-sm h-auto object-contain bg-transparent" 
  alt="" 
/>

          </div>
        </div>
      </div>
    </div>
  );
}
